// extracted by mini-css-extract-plugin
export default {"wrap":"inputCode_wrap__9lUvA"};